<template>
  <Card class="TopicStaticContent">
    <LoadingIndicator v-if="staticContentLoading" />

    <ErrorMessage v-else-if="staticContentError" />

    <div v-else-if="staticContentSuccess">
      <h2 class="TopicStaticContent__heading">
        {{ staticContent.title[selectedLanguage] }}
      </h2>
      <h3 class="TopicStaticContent__subheading">
        {{ staticContent.subtitle[selectedLanguage] }}
      </h3>
      <p
        class="TopicStaticContent__text"
        v-html="staticContent.text[selectedLanguage]">
        <!-- <span v-html="staticContent.text[selectedLanguage]" /> -->
      </p>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Card.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

export default {
  name: 'TopicStaticContent',
  components: {
    Card,
    LoadingIndicator,
    ErrorMessage,
  },
  computed: {
    staticContent() {
      return this.$store.state.content.staticContent;
    },
    staticContentLoading() {
      return this.$store.state.loading.staticContentLoading;
    },
    staticContentError() {
      return this.$store.state.loading.staticContentError;
    },
    staticContentSuccess() {
      return this.$store.state.loading.staticContentSuccess;
    },
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
};
</script>

<style scoped lang="scss">
.TopicStaticContent {
  background-color: #fff;
  overflow: hidden;
}
.TopicStaticContent__heading {
  color: $color--primary;
}
.TopicStaticContent__subheading {
  color: $color--primary;
}
.TopicStaticContent__text {
  @include roboto300;

  /deep/ strong {
    @include roboto400;
    font-weight: 400; // override strong default font-weight
  }
}
</style>
